import React, {useCallback, useEffect, useRef, useState} from 'react';
import {SearchInput} from './search-input';
import {SearchHistory} from './search-history';
import {SearchRecommend} from './search-recommend';
import {SearchResult} from './search-result';
import {SearchEmpty} from './search-empty';
import {getGameList, getLotteryGames} from './search.service';
import Spin from '@/components/basic/spin';
import {useDebounceFn} from 'ahooks';

export default function Search() {
  const [text, setText] = useState('');
  const [list, setList] = useState<any[]>([]);
  const [loadData, setLoadData] = useState(false);
  const [recommendList, setRecommendList] = useState<any[]>([]);
  const [totalSize, setTotalSize] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showRecommend, setShowRecommend] = useState(true);
  const [showEmpty, setShowEmpty] = useState(false);
  const page = useRef({
    pageNo: 1,
    pageSize: 20,
  });
  useEffect(() => {
    // 获取推荐游戏
    getLotteryGames(1001)
      .then((res: any) => {
        setRecommendList(res?.[0]?.gamesList || []);
        setList([]);
      })
      .finally(() => {
        if (!loadData) {
          setLoadData(true);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const searchList = useCallback(async (val: string) => {
    try {
      setLoading(true);
      const res = await getGameList({nickName: val, ...page.current});
      const pageNo = page.current.pageNo;
      setList(prev => {
        if (pageNo === 1) {
          return res.content;
        }
        return [...prev, ...res.content];
      });
      page.current.pageNo++;
      setTotalSize(res.totalSize);
      setShowRecommend(res.content.length === 0);
      setShowEmpty(res.content.length === 0);
    } finally {
      setLoading(false);
    }
  }, []);
  const {run} = useDebounceFn(searchList, {
    wait: 500,
  });
  const handleSearch = (val: string) => {
    if (val.trim().length < 2) {
      setShowRecommend(true);
    }
    setText(val);
    page.current.pageNo = 1;
    if (val.trim().length >= 2) {
      run(val);
    } else {
      setList([]);
      setShowEmpty(false);
    }
  };
  return (
    <Spin loading={loading} style={{height: '100%'}}>
      <SearchInput value={text} onChange={handleSearch} />
      <SearchHistory setText={handleSearch} />
      {list.length > 0 && !showEmpty && (
        <SearchResult
          list={list}
          hasMore={totalSize > list.length}
          totalSize={totalSize}
          loadMore={async () => searchList(text)!}
        />
      )}
      {showEmpty && list.length === 0 && <SearchEmpty />}
      {showRecommend && <SearchRecommend list={recommendList} />}
    </Spin>
  );
}
